import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";
const isAddress = (name) => {
  //Latin-1 without Appendix E
  const re = /^[ "&-.0-:A-Za-z:0-9]{1,27}$/;
  return name && re.test(name)
    ? undefined
    : name === undefined || name?.length === 0
    ? "A valid Street Name must be provided"
    : "A valid Street Name must be provided";
};

const AddressStreetName = ({ ...rest }) => (
  <Field
    name="addressStreetName"
    validate={isAddress}
    label="Street Name"
    autoComplete=""
    component={TextFieldAdapter}
    subscription={{ touched: true, value: true, error: true }}
    fullWidth
    inputProps={{ maxLength: 27 }}
    {...rest}
  />
);

export default AddressStreetName;
